// Auto-generated from OracyAI_Privacy_Policy_India.docx (interim version, 1 June 2025).
// Replace when the lawyer-vetted / Hindi final version lands.
import type { LegalBlock } from "./LegalPage";

export const privacyBlocks: LegalBlock[] = [
  {
    "type": "p",
    "text": "OracyAI (myoracy.ai) | India"
  },
  {
    "type": "p",
    "text": "Effective Date: 1 June 2025"
  },
  {
    "type": "p",
    "text": "This Privacy Policy explains how Oracy Group collects, uses, stores, and protects your personal data when you use the OracyAI platform at myoracy.ai. It is prepared in accordance with the Digital Personal Data Protection Act, 2023 (DPDP Act) and the Digital Personal Data Protection Rules, 2025 (DPDP Rules), as notified by the Ministry of Electronics and Information Technology (MeitY)."
  },
  {
    "type": "p",
    "text": "This policy applies to all users of the platform, including school administrators, teachers, students, and parents or guardians. Where the platform processes the data of children (persons under 18 years of age), additional and enhanced protections apply as set out in this policy."
  },
  {
    "type": "h2",
    "text": "1. Who We Are"
  },
  {
    "type": "p",
    "text": "Data Fiduciary: Oracy Group"
  },
  {
    "type": "p",
    "text": "Platform: OracyAI, accessible at myoracy.ai"
  },
  {
    "type": "p",
    "text": "Operating Centres: Hisar (India), and UAE"
  },
  {
    "type": "p",
    "text": "Contact for Privacy Matters:"
  },
  {
    "type": "li",
    "text": "Email: privacy@oracygroup.com"
  },
  {
    "type": "li",
    "text": "Grievance Officer: See Section 11 of this policy"
  },
  {
    "type": "h2",
    "text": "2. What Personal Data We Collect"
  },
  {
    "type": "p",
    "text": "We collect the following categories of personal data when you use OracyAI:"
  },
  {
    "type": "h3",
    "text": "2.1 Registration and Account Data"
  },
  {
    "type": "li",
    "text": "Full name"
  },
  {
    "type": "li",
    "text": "Email address"
  },
  {
    "type": "li",
    "text": "School or centre name"
  },
  {
    "type": "li",
    "text": "Role (teacher, administrator, student)"
  },
  {
    "type": "li",
    "text": "Year group or age band (for students)"
  },
  {
    "type": "h3",
    "text": "2.2 Voice Recording Data"
  },
  {
    "type": "p",
    "text": "OracyAI requires users to submit spoken language recordings for assessment purposes. These recordings are processed to generate scores across the Physical Strand of the Voice21 oracy framework, including pace, filler words, pause distribution, and clarity."
  },
  {
    "type": "p",
    "text": "Voice recordings may constitute biometric data under applicable law. We treat all voice recordings with the highest level of care, and they are processed only for the defined assessment purposes described in this policy."
  },
  {
    "type": "h3",
    "text": "2.3 Usage and Technical Data"
  },
  {
    "type": "li",
    "text": "Device type and browser information"
  },
  {
    "type": "li",
    "text": "Session timestamps and activity logs"
  },
  {
    "type": "li",
    "text": "Assessment scores and feedback generated by the platform"
  },
  {
    "type": "h2",
    "text": "3. Legal Basis for Processing"
  },
  {
    "type": "p",
    "text": "We process your personal data on the following legal bases under the DPDP Act 2023:"
  },
  {
    "type": "li",
    "text": "Consent: We obtain your free, specific, informed, unconditional, and unambiguous consent before collecting or processing your personal data. Consent is obtained through a clear affirmative action and may be withdrawn at any time."
  },
  {
    "type": "li",
    "text": "Voluntary provision: Where you voluntarily submit data (such as a voice recording) for the purpose of receiving an assessment, that voluntary act constitutes a signal of intent for that specified purpose."
  },
  {
    "type": "li",
    "text": "Contractual necessity: Processing required to deliver the services agreed between your school or centre and Oracy Group."
  },
  {
    "type": "h2",
    "text": "4. Children's Data and Parental Consent"
  },
  {
    "type": "p",
    "text": "OracyAI is designed for use in schools and educational centres with students aged 8 to 18. All users under the age of 18 are considered children under the DPDP Act 2023."
  },
  {
    "type": "h3",
    "text": "4.1 Verifiable Parental Consent"
  },
  {
    "type": "p",
    "text": "We will not process the personal data of any child without first obtaining verifiable consent from their parent or lawful guardian. This consent is obtained as part of the school or centre onboarding process. Schools and centre administrators are responsible for ensuring that parental consent forms are completed and on record before any student uses the platform."
  },
  {
    "type": "h3",
    "text": "4.2 Prohibited Uses of Children's Data"
  },
  {
    "type": "p",
    "text": "In compliance with the DPDP Act 2023, we strictly prohibit the following in relation to children's data:"
  },
  {
    "type": "li",
    "text": "Behavioural tracking or profiling of children"
  },
  {
    "type": "li",
    "text": "Targeted advertising directed at children"
  },
  {
    "type": "li",
    "text": "Use of children's data for any non-essential analytics or commercial purpose"
  },
  {
    "type": "li",
    "text": "Sharing children's data with third parties except as strictly necessary for the delivery of assessment services (see Section 6)"
  },
  {
    "type": "h3",
    "text": "4.3 Data Minimisation for Children"
  },
  {
    "type": "p",
    "text": "We collect only the minimum data necessary to deliver assessment services to student users. We do not request or retain any data beyond what is required for the purposes described in this policy."
  },
  {
    "type": "h2",
    "text": "5. How We Use Your Data"
  },
  {
    "type": "p",
    "text": "We use collected personal data solely for the following purposes:"
  },
  {
    "type": "li",
    "text": "To create and manage user accounts"
  },
  {
    "type": "li",
    "text": "To process voice recordings and generate spoken language assessment scores"
  },
  {
    "type": "li",
    "text": "To provide teachers and administrators with assessment reports and feedback"
  },
  {
    "type": "li",
    "text": "To improve the accuracy and reliability of the assessment platform (using aggregated, non-identifiable data only)"
  },
  {
    "type": "li",
    "text": "To communicate with you regarding your account, the platform, or our services"
  },
  {
    "type": "li",
    "text": "To comply with legal obligations"
  },
  {
    "type": "p",
    "text": "We will not use your data for any purpose not listed above without obtaining fresh consent."
  },
  {
    "type": "h2",
    "text": "6. Third-Party Data Processors"
  },
  {
    "type": "p",
    "text": "We share limited data with trusted third-party processors who support the technical delivery of OracyAI. These processors act under our instructions and are bound by data processing agreements."
  },
  {
    "type": "h3",
    "text": "6.1 Automatic Speech Recognition"
  },
  {
    "type": "p",
    "text": "Voice recordings are processed by AssemblyAI (a US-based provider) for transcription and acoustic feature analysis. Recordings are transmitted securely over encrypted connections. AssemblyAI processes recordings solely for the purpose of generating assessment data and does not retain recordings beyond the processing window."
  },
  {
    "type": "h3",
    "text": "6.2 Platform Infrastructure"
  },
  {
    "type": "p",
    "text": "Platform data is hosted on Neon.tech (PostgreSQL cloud database). Data is stored in compliance with our security obligations under the DPDP Act 2023."
  },
  {
    "type": "h3",
    "text": "6.3 Automated Assessment Scoring"
  },
  {
    "type": "p",
    "text": "Transcripts and derived speech features are processed by large language model providers (OpenAI, US-based, with Groq as a fallback provider) to generate assessment feedback. These providers process the data solely to return scoring output under our instructions and do not use it to train their models."
  },
  {
    "type": "p",
    "text": "We do not sell, rent, or otherwise commercialise your personal data to any third party."
  },
  {
    "type": "h2",
    "text": "7. Cross-Border Data Transfers"
  },
  {
    "type": "p",
    "text": "Some processing of your data occurs outside India (including with AssemblyAI and our scoring providers OpenAI and Groq, all United States based). Such transfers are conducted under contractual safeguards consistent with the requirements of the DPDP Act 2023 and applicable MeitY notifications on cross-border data transfers. By consenting to use of OracyAI, you acknowledge and consent to this processing."
  },
  {
    "type": "h2",
    "text": "8. Data Retention"
  },
  {
    "type": "p",
    "text": "We retain personal data only for as long as is necessary for the purposes described in this policy, or as required by applicable law. Our standard retention periods are:"
  },
  {
    "type": "li",
    "text": "Account data: Retained for the duration of the school or centre's agreement with Oracy Group, plus 5 years following termination"
  },
  {
    "type": "li",
    "text": "Voice recordings: Deleted within 5 years of processing, unless the user or their institution has requested retention for their own records"
  },
  {
    "type": "li",
    "text": "Assessment scores and reports: Retained for the duration of the agreement plus 5  years"
  },
  {
    "type": "p",
    "text": "You may request deletion of your data at any time. On receiving a valid request, we will cease processing and delete your data unless retention is required by law."
  },
  {
    "type": "h2",
    "text": "9. Security"
  },
  {
    "type": "p",
    "text": "We implement appropriate technical and organisational measures to protect personal data against unauthorised access, loss, destruction, or alteration. These include:"
  },
  {
    "type": "li",
    "text": "Encrypted data transmission (TLS/HTTPS)"
  },
  {
    "type": "li",
    "text": "Access controls limiting data access to authorised personnel only"
  },
  {
    "type": "li",
    "text": "Secure cloud storage with regular security reviews"
  },
  {
    "type": "li",
    "text": "Contractual security obligations imposed on all third-party processors"
  },
  {
    "type": "h3",
    "text": "9.1 Data Breach Notification"
  },
  {
    "type": "p",
    "text": "In the event of a personal data breach, we will notify the Data Protection Board of India and affected Data Principals within the timelines prescribed under the DPDP Rules 2025. We will provide information about the nature of the breach and the steps taken to mitigate harm."
  },
  {
    "type": "h2",
    "text": "10. Your Rights as a Data Principal"
  },
  {
    "type": "p",
    "text": "Under the DPDP Act 2023, you have the following rights:"
  },
  {
    "type": "li",
    "text": "Right to access: You may request a summary of the personal data we hold about you and how it is being processed."
  },
  {
    "type": "li",
    "text": "Right to correction: You may request correction of inaccurate or incomplete personal data."
  },
  {
    "type": "li",
    "text": "Right to erasure: You may request deletion of your personal data, subject to any legal retention obligations."
  },
  {
    "type": "li",
    "text": "Right to grievance redressal: You may raise a complaint with our Grievance Officer and receive a response within the timeframes set out in Section 11."
  },
  {
    "type": "li",
    "text": "Right to nominate: You may nominate another person to exercise your rights on your behalf in the event of your death or incapacity."
  },
  {
    "type": "li",
    "text": "Right to withdraw consent: You may withdraw your consent to processing at any time. Withdrawal does not affect the lawfulness of processing carried out before withdrawal."
  },
  {
    "type": "p",
    "text": "To exercise any of these rights, please contact us at the details provided in Section 11."
  },
  {
    "type": "h2",
    "text": "11. Grievance Redressal"
  },
  {
    "type": "p",
    "text": "If you have any concerns or complaints about how we handle your personal data, you may contact our Grievance Officer:"
  },
  {
    "type": "p",
    "text": "Grievance Officer"
  },
  {
    "type": "p",
    "text": "Oracy Group"
  },
  {
    "type": "p",
    "text": "Email: privacy@oracygroup.com"
  },
  {
    "type": "p",
    "text": "We will acknowledge your complaint within 48 hours and aim to resolve it within 30 days of receipt. If you are not satisfied with our response, you have the right to file a complaint with the Data Protection Board of India, once it is operational."
  },
  {
    "type": "h2",
    "text": "12. Language Accessibility"
  },
  {
    "type": "p",
    "text": "In compliance with the DPDP Rules 2025, this Privacy Policy is available in English. We are committed to making it available in additional scheduled languages of India as required. Please contact us if you require this policy in another language."
  },
  {
    "type": "h2",
    "text": "13. Changes to This Policy"
  },
  {
    "type": "p",
    "text": "We may update this Privacy Policy from time to time. Where changes are material, we will notify you by email or via the platform before the changes take effect. Continued use of the platform following notification constitutes acceptance of the updated policy."
  },
  {
    "type": "h2",
    "text": "14. Contact Us"
  },
  {
    "type": "p",
    "text": "For any questions about this Privacy Policy or about how we handle your data:"
  },
  {
    "type": "li",
    "text": "Email: privacy@oracygroup.com"
  },
  {
    "type": "li",
    "text": "Platform: myoracy.ai"
  },
  {
    "type": "li",
    "text": "Organisation: Oracy Group"
  },
  {
    "type": "p",
    "text": "This document constitutes the Privacy Policy of OracyAI (myoracy.ai) and is effective from the date stated above."
  }
];
